import { render, staticRenderFns } from "./ClientSharedCamerasTab.vue?vue&type=template&id=c88f7c5a&"
import script from "./ClientSharedCamerasTab.vue?vue&type=script&lang=js&"
export * from "./ClientSharedCamerasTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports